import config from 'config';
import { getAPIToken } from 'state/authentication/authService';

const { apiEndpoint } = config;

export const getDownloadUrl = (fileId, clientId) => {
  const token = getAPIToken();
  return `${apiEndpoint}/files/${fileId}?token=${token}&clientId=${clientId}`;
};
